import { getEnvironmentTypeIcon } from '@/react/portainer/environments/utils';
import dockerEdge from '@/assets/ico/docker-edge-environment.svg';
import podmanEdge from '@/assets/ico/podman-edge-environment.svg';
import kube from '@/assets/images/kubernetes_endpoint.png';
import kubeEdge from '@/assets/ico/kubernetes-edge-environment.svg';
import {
  ContainerEngine,
  EnvironmentType,
} from '@/react/portainer/environments/types';
import azure from '@/assets/ico/vendor/azure.svg';
import docker from '@/assets/ico/vendor/docker.svg';
import dockerSwarm from '@/assets/ico/vendor/docker-swarm.svg';
import podman from '@/assets/ico/vendor/podman.svg';

import { Icon } from '@@/Icon';

interface Props {
  type: EnvironmentType;
  containerEngine?: ContainerEngine;
  // a D2K environment in Swarm mode
  swarm?: boolean;
}

export function EnvironmentIcon({ type, containerEngine, swarm }: Props) {
  const imageWidth = 30;
  switch (type) {
    case EnvironmentType.AgentOnDocker:
    case EnvironmentType.Docker:
      if (containerEngine === ContainerEngine.Podman) {
        return (
          <img
            src={podman}
            width={imageWidth}
            alt="podman environment"
            aria-hidden="true"
          />
        );
      }
      if (swarm) {
        return (
          <img
            src={dockerSwarm}
            width={imageWidth}
            alt="docker swarm environment"
            aria-hidden="true"
          />
        );
      }
      return (
        <img
          src={docker}
          width={imageWidth}
          alt="docker environment"
          aria-hidden="true"
        />
      );
    case EnvironmentType.Azure:
      return (
        <img
          src={azure}
          width={imageWidth}
          alt="azure environment"
          aria-hidden="true"
        />
      );
    case EnvironmentType.EdgeAgentOnDocker:
      if (containerEngine === ContainerEngine.Podman) {
        return (
          <img
            src={podmanEdge}
            width={imageWidth}
            alt="podman edge environment"
            aria-hidden="true"
          />
        );
      }
      return (
        <img
          src={dockerEdge}
          width={imageWidth}
          alt="docker edge environment"
          aria-hidden="true"
        />
      );
    case EnvironmentType.KubernetesLocal:
    case EnvironmentType.AgentOnKubernetes:
      return (
        <img
          src={kube}
          width={imageWidth}
          alt="kubernetes environment"
          aria-hidden="true"
        />
      );
    case EnvironmentType.EdgeAgentOnKubernetes:
      return (
        <img
          src={kubeEdge}
          width={imageWidth}
          alt="kubernetes edge environment"
          aria-hidden="true"
        />
      );
    default:
      return (
        <Icon
          icon={getEnvironmentTypeIcon(type, containerEngine, swarm)}
          className="blue-icon !h-16 !w-16"
        />
      );
  }
}
